import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/"
import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }


    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }

    render() {
        return (
            <ParadigmaModal
                fileUploader={true}
                getUrl={api.proyectos.config.plantillas.detail}
                postUrl={api.proyectos.config.plantillas.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}

                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"La Plantilla ha sido editada con éxito."}
                title={"Editar Plantilla"}
                buttonTitle={"Editar Plantilla"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.SetData(data)}>
                <div className="ui-form">
                    <PlantillaFormSections fileUrl={this.state.fileurl} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Plantillas/Edit.js